import request from '@@/utils/request'
/** 查询图片 */
export function getImgApi(fileGuId) {
    return request({
        url: '/yz/handleImg/getImg/'+fileGuId,
        headers: {
            isToken: false
        },
        responseType: 'blob',
        method: 'get'
    })
}
export function wxLoginApi() {
    return request({
        url: '/yw/wechat/wxLogin',
        headers: {
            isToken: false
        },
        method: 'get'
    })
}
export function getWxDataApi() {
    return request({
        url: '/yw/wechat/getWxData',
        headers: {
            isToken: false
        },
        method: 'get'
    })
}